<template>
    <div class="result-tips">
        <div class="result-tips_heading">Поради від <b>ukasko.connect</b></div>
        <div class="result-tips_content">
            <div :class="['result-tips_slide', {'active' : index === active}]" v-for="(slide, index) in slides" :key="index">
                <div class="result-tips_img">
                    <img :src="slide.url" alt="">
                </div>
                <div class="result-tips_descr" v-html="slide.text"></div>
            </div>
            <div class="result-tips_nav">
                <span :class="{'active' : index === active}" v-for="(number, index) in slides.length" :key="number.index" @click="active = index">{{index+1}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            active: 0,
            slides: [
                {url: '/images/result-tip1.svg', text: `Якщо заплутались в кількості пропозицій, використовуйте <b>фільтри</b> вгорі сторінки`},
                {url: '/img/prompills-preview.05ce17d4.svg', text: `Якщо заплутались в кількості пропозицій, використовуйте <b>фільтри</b> вгорі сторінки2`},
                {url: 'https://ukasko.ua/storage/logos/company/nszjymzy3c8rbhfln2samj0qonk7vbiihrhxqsa5.png', text: `Якщо заплутались в кількості пропозицій, використовуйте <b>фільтри</b> вгорі сторінки3`},
                {url: '/img/logo_connect.7d5d8574.svg', text: `Якщо заплутались в кількості пропозицій, використовуйте <b>фільтри</b> вгорі сторінки4`},
                {url: '/img/aboutUs-insurance_icon.907bfe9b.svg', text: `Якщо заплутались в кількості пропозицій, використовуйте <b>фільтри</b> вгорі сторінки5`}
            ]
        }
    },
    mounted: function () {
        setInterval(() => {
            if (this.active+1 === this.slides.length) {
                this.active = 0;
            } else {
                this.active += 1;
            }
        }, 5000);
    }
}
</script>